<template>
  <el-dialog 
    :title=dialogTitle
    :visible.sync="dialogAddSuppliersVisible" 
    :before-close="cancel"
    width="30%"
    :close-on-click-modal="false"
    center
  >
    <el-form :model="supplierForm" status-icon :rules="rules" ref="supplierForm" label-width="100px" class="add-user-form">
      <el-form-item label="inedx" prop="index">
        <el-input type="text" v-model="supplierForm.index" disabled></el-input>
      </el-form-item>
      <el-form-item label="tag" prop="tag">
        <el-select 
          v-model="supplierForm.tag" 
          allow-create 
          default-first-option
          filterable
          placeholder="请选择tag类型"
          style="display: initial;"
        >
          <el-option
            v-for="item in tagList"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          >
            <span style="float: right;color: #8492a6; font-size: 13px">{{ item.label }}</span>
            <span style="float: left; ">{{ item.value }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="广告位id" prop="adspotId">
        <el-input type="text" v-model="supplierForm.adspotId" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="appId" prop="appId">
        <el-input type="text" v-model="supplierForm.appId" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit('supplierForm')">保存</el-button>
      <el-button @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogAddSuppliersVisible: {
      type: Boolean,
      default: false
    },
    isEditSupplier: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      // tag 初始列表
      // TODO：创建条目之后，保存到tagList中
      tagList: [
        { value: 'csj', label: '头条-穿山甲SDK' },
        { value: 'ylh', label: '腾讯-优量汇SDK（前广点通）' },
        { value: 'ks', label: '快手-快手联盟SDK' },
        { value: 'bd', label: '百度-百青藤SDK' },
      ],
      supplierForm: {
        tag: '',
        adspotId: '',
        appId: '',
        index: null
      },
      rules: {
        tag: [
          { required: true, message: '请选择tag...', trigger: 'change' }
        ],
        adspotId: [
          { required: true, message: '请填写广告位id', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请填写appId', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.isEditSupplier ? '编辑渠道' : '新建渠道';
    }
  },
  methods: {
    open (row) {
      if (!row) {
        this.$nextTick(function () {
          this.$refs.supplierForm.resetFields();
          // 拿当前的index.
          var currentSupplierIndex = parseInt(sessionStorage.getItem('supplier_index')) ? parseInt(sessionStorage.getItem('supplier_index')) : 4;

          this.supplierForm.index = ++currentSupplierIndex;
        })
      } else {
        this.supplierForm = Object.assign({}, row);
      }
    },

    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var supplierForm = {
            tag: this.supplierForm.tag,
            adspotId: this.supplierForm.adspotId,
            appId: this.supplierForm.appId,
            index: this.supplierForm.index
          }
          this.$emit('submit', supplierForm);
        }
      });
    },

    cancel () {
      this.$refs.supplierForm.resetFields();
      this.$emit('cancel');
    }
  }
}
</script>

<style lang="scss" scpoed>

</style>



// WEBPACK FOOTER //
// src/components/AddSuppliers.vue